import router from './router'
import { getToken } from '@/utils/auth'
import { removeItem } from '@/utils/localStorage'
import { jwtDecode } from 'jwt-decode'

function isTokenInvalid(token) {
  if (!token || !token.access_token) return true

  try {
    const decoded = jwtDecode(token.access_token)
    const now = Date.now() / 1000
    return decoded.exp < now
  } catch (e) {
    return true
  }
}

router.beforeEach((to, from, next) => {
  const token = getToken()
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)

  if (requiresAuth && isTokenInvalid(token)) {
    removeItem('user')
    return next({ name: 'Login' })
  }

  next()
})
